export class Sign {
  signNo: number;
  name: string;
  position: string;
  department: string;
  mobileNumber: string;
  faxNumber: string;
  email: string;
  url: string;
  sinkUrl: string;
  regDate: Date;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/common/model/sign/sign.model.ts